import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { LANDING_FAQ } from "../../data/landingContent";

export const LandingFaq = () => (
  <section className="border-b border-white/10 bg-[#030206]" data-testid="landing-faq">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-20 sm:px-6 md:px-10 lg:grid-cols-12 lg:py-28">
      <div className="lg:col-span-4">
        <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-purple-300">Questions before you buy</div>
        <h2 className="mt-4 font-display text-3xl font-black leading-[1.05] text-white sm:text-4xl">Clear answers. No small print.</h2>
        <p className="mt-5 text-sm leading-relaxed text-zinc-400">Still unsure? Use the contact form and speak to the team behind the product.</p>
      </div>
      <Accordion type="single" collapsible className="space-y-2 lg:col-span-8" data-testid="landing-faq-accordion">
        {LANDING_FAQ.map((item, index) => (
          <AccordionItem key={item.q} value={`faq-${index}`} className="border border-zinc-800 bg-[#09080b] px-5 transition-colors data-[state=open]:border-purple-400/60" data-testid={`landing-faq-item-${index}`}>
            <AccordionTrigger className="py-5 text-left font-display text-lg font-bold text-white hover:no-underline" data-testid={`landing-faq-trigger-${index}`}>{item.q}</AccordionTrigger>
            <AccordionContent className="pb-5 text-sm leading-relaxed text-zinc-300 sm:text-base">{item.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);